import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=ad5db470&scoped=true&lang=pug"
import script from "./checkbox.vue?vue&type=script&lang=ts"
export * from "./checkbox.vue?vue&type=script&lang=ts"
import style0 from "./checkbox.scss?vue&type=style&index=0&id=ad5db470&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5db470",
  null
  
)

export default component.exports